export default "__VITE_ASSET__CNIbVa9h__"